export default function logout () {
  fetch('/sso/logout?redirect=/sso/login', {
    method: 'POST'
  })
}
